export default [{
    path: '/unsigned-contracts',
    name: 'unsigned-contracts',
    component: () => import('@/views/modules/Contracts/index.vue'),
    props: {
      isSigned: false,
      waitingList: false,
    },
    meta: {
      breadcrumb: [{
        text: 'contract.unsigned_contracts',
        active: true,
      }, ],
      unique_name: "unsigned-contracts"
    },
  },
  {
    path: '/signed-contracts',
    name: 'signed-contracts',
    component: () => import('@/views/modules/Contracts/index.vue'),
    props: {
      isSigned: true,
      waitingList: false,
    },
    meta: {
      breadcrumb: [{
        text: 'contract.signed_contracts',
        active: true,
      }, ],
      unique_name: "signed-contracts"
    },
  },
  {
    path: '/contracts/:id',
    name: 'contract-edit',
    component: () => import('@/views/modules/Contracts/addOrEditContract_v2.vue'),
    props: {
      isEdit: true,
    },
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'contract.unsigned_contracts',
          active: false,
          to: '/unsigned-contracts',
        },
        {
          text: 'Номер договора',
          active: true,
        },
      ],
      unique_name: "unsigned-contracts"
    },
  },
  {
    path: '/contracts/:id/view',
    name: 'contract-view',
    component: () => import('@/views/modules/Contracts/view.vue'),
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'contract.unsigned_contracts',
          active: false,
          to: '/unsigned-contracts',
        },
        {
          text: 'Номер договора',
          active: true,
        },
      ],
      unique_name: "unsigned-contracts"
    },
  },
  {
    path: '/contract/add-new',
    name: 'new-contract',
    component: () => import('@/views/modules/Contracts/addOrEditContract_v2.vue'),
    props: {
      isEdit: false,
    },
    meta: {
      breadcrumb: [{
          text: 'Договоры',
          active: false,
        },
        {
          text: 'Создание нового договора',
          active: true,
        },
      ],
      unique_name: "unsigned-contracts"
    },
  },
  {
    path: '/contract/add-old',
    name: 'old-contract',
    component: () => import('@/views/modules/Contracts/addOrEditContractOld.vue'),
    props: {
      isEdit: false,
    },
    meta: {
      breadcrumb: [{
          text: 'contract.unsigned_contracts',
          active: false,
        },
        {
          text: 'contract.add_old_contract',
          active: true,
        },
      ],
      unique_name: "unsigned-contracts"
    },
  },
  {
    path: '/contract/requests-to-edit',
    name: 'requests-list',
    component: () => import('@/views/modules/Contracts/index.vue'),
    props: {
      waitingList: true,
      isSigned: false,
    },
    meta: {
      breadcrumb: [{
        text: 'contract.requests_to_edit',
        active: true,
      }, ],
      unique_name: "contract-requests-to-edit"
    },
  },
  {
    path: '/contract/pdf-content/:id',
    name: 'contract-pdf-content',
    component: () => import('@/views/modules/Contracts/components/pdfContent.vue'),
    meta: {
      breadcrumb: [{
          text: 'Договоры',
          active: false,
        },
        {
          text: 'Номер договора',
          active: true,
        },
      ],
      unique_name: "contract-requests-to-edit"
    },
  },
]